export default {"src":"/oferta/_next/static/media/menopause.dd9092d2.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};